export default "__VITE_ASSET__CQAnMRDk__"